module.exports = __webpack_public_path__ + "img/content-with-img-links-lincoln.c7f1ede1.jpg";